import { typeWireGroupOf } from "@typewirets/core";
import { DeepResearchReportsAPIWire } from "@/lib/api/deep-research-reports.api.wire";
import { EntitiesAPIWire } from "@/lib/api/entities.api.wire";
import {
  ASTSerializerWire,
  FormulaParserWire,
} from "@/lib/formula-parser.wire";
import { FormulaValidationServiceWire } from "@/lib/formula-validation-service.wire";
import { QueryClientWire } from "@/lib/query-client.wire";
import { PrefixedStorageLoaderWire } from "@/lib/storage/sync-json-storage.wire";

export const MainWires = typeWireGroupOf([
  PrefixedStorageLoaderWire,
  ASTSerializerWire,
  FormulaParserWire,
  FormulaValidationServiceWire,
  DeepResearchReportsAPIWire,
  EntitiesAPIWire,
  QueryClientWire,
]);
